export function ComboboxDivider() {
  return <div className="border-t border-primary mx-4 my-1" />;
}
